module.exports = __webpack_public_path__ + "./fonts/fontawesome-webfont3e6e.woff2";